if (!customElements.get("gift-card-fields")) {
  customElements.define(
    "gift-card-fields",
    class GiftCardFields extends HTMLElement {
      connectedCallback() {
        this.productInfo = this.closest("product-info");
        this.quantity = this.productInfo.querySelector('[name="quantity"]');
        this.entries = this.querySelector("[data-gift-card-entries]");
        this.template = this.querySelector("template");
        this.onQuantityChange = this.updateFields.bind(this);
        this.quantity.addEventListener("input", this.onQuantityChange);
        this.quantity.addEventListener("change", this.onQuantityChange);
        this.quantityUnsubscriber = subscribe(
          PUB_SUB_EVENTS.quantityUpdate,
          this.onQuantityChange
        );
        this.updateFields();
      }

      disconnectedCallback() {
        this.quantity.removeEventListener("input", this.onQuantityChange);
        this.quantity.removeEventListener("change", this.onQuantityChange);
        this.quantityUnsubscriber?.();
      }

      updateFields() {
        const quantity = Number(this.quantity.value);
        if (!Number.isInteger(quantity) || quantity < 1 || !this.quantity.validity.valid) return;

        while (this.entries.children.length < quantity) {
          const entry = this.template.content.firstElementChild.cloneNode(true);
          const index = this.entries.children.length + 1;
          entry.querySelector("[data-gift-card-number]").textContent = index;
          entry.querySelectorAll("[data-gift-card-property]").forEach((input, fieldIndex) => {
            input.id = `${this.dataset.idPrefix}-${index}-${fieldIndex + 1}`;
            entry.querySelectorAll("label")[fieldIndex].htmlFor = input.id;
          });
          this.entries.appendChild(entry);
        }

        // Keep removed cards' values when the customer increases quantity again.
        Array.from(this.entries.children).forEach((entry, index) => {
          entry.hidden = index >= quantity;
          entry.disabled = index >= quantity;
        });
      }

      getItems(formData) {
        this.updateFields();
        const properties = {};
        for (const [name, value] of formData) {
          const match = name.match(/^(?:properties|\[properties\])\[([^\]]+)\]$/);
          if (match) properties[match[1]] = value;
        }

        return Array.from(this.entries.children)
          .filter((entry) => !entry.disabled)
          .map((entry) => {
            const cardProperties = { ...properties };
            entry.querySelectorAll("[data-gift-card-property]").forEach((input) => {
              cardProperties[input.dataset.giftCardProperty] = input.value;
            });
            // Shopify validates and delivers recipient gift cards only with this flag.
            cardProperties.__shopify_send_gift_card_to_recipient = "true";
            const item = { id: formData.get("id"), quantity: 1, properties: cardProperties };
            if (formData.get("selling_plan")) item.selling_plan = formData.get("selling_plan");
            return item;
          });
      }
    }
  );
}
